// @ts-check
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  wrapFormComponentWithLabelAndError,
  wrapFormComponentWithError,
} from './StyledFormComponentWrappers';
import LoadingContent from 'shared/components/LoadingContent';
import _ from 'lodash';

import connectFormComponentToReduxForm from 'utils/connectFormComponentToReduxForm';

class AutoSelect extends Component {
  componentDidMount() {
    this.autoSelect(this.props);
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.value !== this.props.value ||
      prevProps.valueKey !== this.props.valueKey ||
      !_.isEqual(prevProps.options, this.props.options)
    ) {
      this.autoSelect(this.props);
    }
  }

  autoSelect({ value, onChange, options, valueKey }) {
    // update value to the first option if the current value doesn't match any options.
    if (onChange) {
      const flattenedOptions = _.flatten(
        (options || []).map(option => (option.options ? option.options : option))
      );
      const selectedOption = flattenedOptions.find(option => option[valueKey] === value);
      if (!selectedOption && flattenedOptions.length) {
        onChange(flattenedOptions[0][valueKey]);
      }
    }
  }

  render() {
    return <DumbSelect {...this.props} />;
  }
}

const DumbSelect = ({ options, labelKey, valueKey, onChange, ...rest }) => (
  <select onChange={e => onChange(e.target.value)} {...rest}>
    {options.map(o => {
      if (o.options) {
        return (
          <optgroup key={o[labelKey]} label={o[labelKey]}>
            {o.options.map(so => (
              <option key={`${so[valueKey]}${so[labelKey]}`} value={so[valueKey]}>
                {so[labelKey]}
              </option>
            ))}
          </optgroup>
        );
      } else {
        return (
          <option key={`${o[valueKey]}${o[labelKey]}`} value={o[valueKey]}>
            {o[labelKey]}
          </option>
        );
      }
    })}
  </select>
);

const RawPlainSelect = props => {
  const {
    options,
    isLoading,
    labelKey = 'label',
    valueKey = 'value',
    prompt = 'Select...',
    ...rest
  } = props;

  if (isLoading) {
    return <LoadingContent />;
  }

  let allOptions = options;

  // Add prompt option
  if (prompt !== false) {
    allOptions = [{ [valueKey]: '', [labelKey]: prompt }].concat(allOptions);
  }

  return <AutoSelect options={allOptions} labelKey={labelKey} valueKey={valueKey} {...rest} />;
};

RawPlainSelect.displayName = 'RawPlainSelect';

RawPlainSelect.propTypes = {
  options: PropTypes.array.isRequired,
};

export { RawPlainSelect };

const RawPlainSelectField = wrapFormComponentWithLabelAndError(RawPlainSelect);
RawPlainSelectField.displayName = 'RawPlainSelectField';

const PlainSelectField = connectFormComponentToReduxForm(RawPlainSelectField);
PlainSelectField.displayName = 'PlainSelectField';
export default PlainSelectField;

const PlainSelectInput = connectFormComponentToReduxForm(
  wrapFormComponentWithError(RawPlainSelect)
);

export { PlainSelectInput };
